var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStripes = function SvgStripes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 111.104,
    viewBox: "0 0 76 111.104",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stripes",
    transform: "translate(-23.5 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5307",
    "data-name": "Grupo 5307",
    transform: "translate(24 188)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4264",
    "data-name": "Caminho 4264",
    d: "M0,34.822V29.465L29.465,0h5.357Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4265",
    "data-name": "Caminho 4265",
    d: "M1150.667,1147.985v2.681h-2.681Z",
    transform: "translate(-1075.668 -1075.668)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4266",
    "data-name": "Caminho 4266",
    d: "M0,45.536V40.179L40.179,0h5.357Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4267",
    "data-name": "Caminho 4267",
    d: "M0,24.109V18.752L18.752,0h5.357Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4268",
    "data-name": "Caminho 4268",
    d: "M0,13.395V8.038L8.038,0h5.357Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4269",
    "data-name": "Caminho 4269",
    d: "M2.678,75H0V72.32L72.32,0H75V2.678Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4270",
    "data-name": "Caminho 4270",
    d: "M0,56.25V50.893L50.893,0h5.357Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4271",
    "data-name": "Caminho 4271",
    d: "M0,2.681V0H2.681Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4272",
    "data-name": "Caminho 4272",
    d: "M643.125,672.59h-5.357l34.823-34.823v5.357Z",
    transform: "translate(-597.591 -597.591)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4273",
    "data-name": "Caminho 4273",
    d: "M0,66.963V61.606L61.607,0h5.357Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4274",
    "data-name": "Caminho 4274",
    d: "M983.271,991.309h-5.357l13.395-13.4v5.357Z",
    transform: "translate(-916.31 -916.31)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4275",
    "data-name": "Caminho 4275",
    d: "M813.2,831.951h-5.357l24.109-24.109V813.2Z",
    transform: "translate(-756.952 -756.952)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4276",
    "data-name": "Caminho 4276",
    d: "M473.052,513.231h-5.357l45.536-45.536v5.357Z",
    transform: "translate(-438.232 -438.232)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4277",
    "data-name": "Caminho 4277",
    d: "M132.905,194.512h-5.357l66.964-66.964V132.9Z",
    transform: "translate(-119.513 -119.513)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4278",
    "data-name": "Caminho 4278",
    d: "M302.981,353.874h-5.357l56.25-56.25v5.357Z",
    transform: "translate(-278.875 -278.875)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_14",
    "data-name": "Subtra\\xE7\\xE3o 14",
    d: "M22505.105,1841v0h-5.359l16.254-16.253v5.361L22505.107,1841Zm-10.717,0v0h-5.354l26.965-26.964v5.356L22494.391,1841Zm-10.711,0v0h-5.359l35-35H22516v2.681l-32.32,32.32Zm-10.717,0v0h-5.354l35-35h5.355l-35,35Zm-10.715,0v0h-5.355l35-35h5.361l-35,35Zm-10.713,0v0h-5.354l35-35h5.355l-35,35Zm64.285,0h-5.355l5.537-5.536v5.355l-.182.181Zm-74.818-.181v-5.355l29.463-29.464h5.361L22441,1840.818Zm0-10.711v-5.356l18.752-18.753h5.355L22441,1830.107Zm0-10.711v-5.361l8.035-8.036h5.361L22441,1819.4Zm0-10.717V1806h2.68l-2.678,2.679Z",
    transform: "translate(-22417 -1543)",
    fill: "currentColor",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStripes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stripes.7794514b.svg";
export { ForwardRef as ReactComponent };